import React from 'react';
import { connect } from 'react-redux';
import SearchBarDropDown from 'components/common/searchbardropdown';
import { updateUser } from 'actions/myaccount';
import toastr from 'toastr';
import Tree from 'containers/tree';
import enhanceWithClickOutside from "react-click-outside";

export class SearchContainer extends React.Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            showSearch: false,
            showAllNodes: true
        };
        this.showSearchBar = this.showSearchBar.bind(this);
        this.hideSearchBar = this.hideSearchBar.bind(this);
        this.addNodeWidget = this.addNodeWidget.bind(this);
    }
    showSearchBar() {
        this.setState({ showSearch: true });
    }
    hideSearchBar() {
        this.setState({ showSearch: false });
    }
    addNodeWidget(node) {
        let user = Object.assign({}, this.props.user);
        if (!user.details || !user.details.location) {
            user.details = user.details || {};
            user.details.location = [node.id];
            this.props.dispatch(updateUser(user.username, user));
        }
        else if (user.details.location.includes(node.id)) {
            toastr.error("Already has a widget for this location.")
        } else {
            user.details.location = [...user.details.location, node.id];
            this.props.dispatch(updateUser(user.username, user));
        }
    }
    handleClickOutside() {
        this.hideSearchBar()
    }
    render() {
        console.log("this.props.tree", this.props.tree)
        return (
            <div className="grid-widget-card" >
                <div className="widget-card widget-card-add box--shadow bg--white  cursor--pointer" onClick={this.showSearchBar}>
                    {/* set height of inner div equal to the height of the card to position center */}
                    <div className="flex--vertical--horizontal search-dropdown-root" style={{
                        minHeight: "525px",
                        maxHeight: "525px"
                    }}>

                        {this.state.showSearch ?
                            <div className=" location-dropdown-search-container" style={{ width: "100%" }}>

                                <SearchBarDropDown
                                    onChange={(node) => { this.addNodeWidget(node) }}
                                    tree={this.props.tree}
                                    onOpen={() => {
                                        this.setState({
                                            showAllNodes: false
                                        })
                                    }}
                                    onClose={() => {
                                        this.setState({
                                            showAllNodes: true
                                        })
                                    }}
                                />
                                <Tree showAllNodes={this.state.showAllNodes}
                                    tree={this.props.tree}
                                    statistic={(node) => { this.addNodeWidget(node); this.hideSearchBar(); }} />


                            </div>
                            :
                            <div className="widget-card-add-btn cursor--pointer">
                                <span className="font-icon icon-addicon" />
                            </div>}

                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        user: state.myAccountReducer.user,
        tree: state.overviewReducer.customerOverview
    };
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(enhanceWithClickOutside(SearchContainer));



// WEBPACK FOOTER //
// ./src/components/pages/overview/searchcontainer.jsx